import { render, staticRenderFns } from "./picViewRecycle.vue?vue&type=template&id=99b7235e&scoped=true&"
import script from "./picViewRecycle.vue?vue&type=script&lang=js&"
export * from "./picViewRecycle.vue?vue&type=script&lang=js&"
import style0 from "./picViewRecycle.vue?vue&type=style&index=0&id=99b7235e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b7235e",
  null
  
)

export default component.exports